
import BaseModelMemo from "@/models/BaseModelMemo.js";

export const GridConfig = {
	list: BaseModelMemo.list,
	columns: BaseModelMemo.columns,
	// query: {
	// 	limit: 5000
	// },
	grid: {
		gridId: 'MemoGrid',
		checkbox: true,
		edit: true,
		delete: true,
		pageSize: 100,
		groupable: true,
		actionsColumnWidth:80,
		height: 500,
		sort: [{ field: "TaxPeriod", dir: "desc" }]
	}
}

export const ToolbarConfig = {
	list: 'ToolBarItems',
	items: [{
			id: "btnAddMemo",
			type: "button",
			text: "Add Memo Text",
			showIcon: "toolbar",
			icon: "plus-circle",
			attributes: {
				"class": "float-right-btn btn btn-primary"
			},
		},
	]
}